import TasksLayout from "../components/layouts/TasksLayout.vue";
import TasksIndexPage from "../pages/TasksIndexPage.vue";
import TaskShowPage from "../pages/TaskShowPage.vue";
import TaskTemplateShowPage from "../pages/TaskTemplateShowPage.vue";
import TaskBucketsTabPage from "../pages/tabs/TaskBucketsTabPage.vue";
import TaskTemplatesTabPage from "../pages/tabs/TaskTemplatesTabPage.vue";
import TasksTabPage from "../pages/tabs/TasksTabPage.vue";

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
  {
    // This is the parent route for your package.
    // It uses the layout component.
    path: "/tasks",
    name: "tasks.root",
    component: TasksLayout,
    meta: {
      // e.g., requiresAuth: true
      // requiresAuth: true,
      // title: 'tasks.nav.title',
      layout: "Authenticated",
    },
    // All other package routes are children of this layout
    children: [
      {
        // Child path is empty, so it renders at /tasks
        path: "",
        name: "TasksIndexPage",
        component: TasksIndexPage,
        beforeEnter: (to) => {
          if (to.name === "TasksIndexPage") {
            return { name: "TasksTabTasksPage" };
          }

          return true;
        },
        children: [
          {
            path: "",
            name: "TasksTabTasksPage",
            component: TasksTabPage,
          },
          {
            path: "templates",
            name: "TasksTabTemplatesPage",
            component: TaskTemplatesTabPage,
          },
          {
            path: "buckets",
            name: "TasksTabBucketsPage",
            component: TaskBucketsTabPage,
          },
        ],
      },
      {
        path: "task/:task",
        name: "TaskShowPage",
        component: TaskShowPage,
      },
      {
        path: "task-template/:taskTemplate",
        name: "TaskTemplateShowPage",
        component: TaskTemplateShowPage,
      },
      // --- Example of other child routes ---
      // {
      //   path: 'create', // Renders at /tasks/create
      //   name: 'tasks.create',
      //   component: () => import('../components/Create.vue'),
      // },
    ],
  },
];
